/**
 * Otimização de imagens do Storage (Lovable Cloud).
 *
 * As fotos dos imóveis são enviadas em PNG/JPG originais (até ~1 MB cada), o que
 * destrói o LCP das páginas de detalhe. O endpoint de renderização do Storage
 * entrega a mesma imagem redimensionada e em WebP (negociação por Accept),
 * reduzindo tipicamente 600 KB → 35 KB.
 */

const PUBLIC_PATH = "/storage/v1/object/public/";
const RENDER_PATH = "/storage/v1/render/image/public/";

/** Retorna a URL otimizada (largura máxima + qualidade). No-op fora do Storage. */
export function optimizedImage(
  url: string | null | undefined,
  width: number,
  quality = 72
): string {
  if (!url) return "/placeholder.svg";
  if (!url.includes(PUBLIC_PATH)) return url;
  const [base] = url.split("?");
  return `${base.replace(PUBLIC_PATH, RENDER_PATH)}?width=${width}&quality=${quality}&resize=contain`;
}

/** srcset responsivo para imagens do Storage (vazio quando não aplicável). */
export function optimizedSrcSet(
  url: string | null | undefined,
  widths: number[] = [640, 1024, 1600],
  quality = 72
): string | undefined {
  if (!url || !url.includes(PUBLIC_PATH)) return undefined;
  return widths.map((w) => `${optimizedImage(url, w, quality)} ${w}w`).join(", ");
}
